module.exports.stripe = {
  publishKey: "pk_live_ska8KrEdOcVti3FMgio2PMeY", //'pk_test_TJVaveIhhSwHFK9zy3FEA6Ar', 'pk_live_ska8KrEdOcVti3FMgio2PMeY'
};

module.exports.google = {
  mapApiKey: "AIzaSyCBkWiGVHsVpBWs9ULCqYjRAf_KZUcFjnw",
};



// WEBPACK FOOTER //
// ./client/react/common/config.js